import type { IntlShape } from "react-intl";
import type { UserRoles } from "~enums/userRoles";
import type { UserResponse } from "~types/user";
import { userRolesByPriority } from "../../constants/userRolesByPriority";
import { UserStatuses } from "../enums/userStatuses";
import type { UserTransformed } from "../types";

const transformUsersResponse = (response: UserResponse, formatMessage: IntlShape["formatMessage"]): UserTransformed[] =>
  (response?.data || []).map((user) => {
    const allRoles = [
      ...(user.userBasedPermissions?.map(({ userRole }) => userRole) || []),
      ...(user.roleBasedPermissions?.map(({ userRole }) => userRole) || []),
    ] as UserRoles[];
    const userRolesSet = new Set(allRoles);
    const userRolesStr = [...userRolesSet]
      .sort((a, b) => userRolesByPriority.indexOf(a) - userRolesByPriority.indexOf(b))
      .map((userRole) => formatMessage({ id: `permissions.userRole.${userRole}` }))
      .join(", ");

    return {
      ...user,
      status: user.isPending ? UserStatuses.Pending : UserStatuses.Active,
      userRolesSet,
      userRolesStr,
    };
  });

export default transformUsersResponse;
